import React, { useState, useEffect } from "react";
import SideMenu from "./SideMenu";
import DashboardForm from "./DashboardForm";
import AdminDataTable from "./AdminDataTable";
import { useAppContext } from "../../contexts/AppContext";
import Register from "../Register/Register";
import UserList from "./UserList";
import TranslationForm from "../Translation/TranslatioForm";
import TranslationList from "../Translation/TranslationList";
import TestimonialsAdmin from "./TestimonialsFetchedElements";
import ProfileUpdate from "./ProfileUpdate";

function ContentManagementForm() {
  const { backendUrl, loggedUser } = useAppContext();

  const [activeItem, setActiveItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentEditData, setCurrentEditData] = useState(null);

  const isSuperAdmin = loggedUser?.role === "superadmin";

  const commonColumns = [
    { key: "title", label: "Title" },
    { key: "content", label: "Content", type: "html" },
  ];

  const mediaColumns = [
    { key: "images", label: "Media", type: "image" },
    ...commonColumns
  ];

  const admin_list = [
    {
      icon: "bi bi-grid-fill",
      elements: "Services list",
      apiEndPoint: `${backendUrl}/ServiceList`,
      columns: mediaColumns,
      formEntries: {
        content: "service description",
        title: "service title",
        photo: "service photo",
        heading: "services",
        apiEndPoint: `${backendUrl}/ServiceList`,
      },
      reorderable: true,
    },
    {
      icon: "bi bi-person-badge-fill",
      elements: "Doctors info",
      apiEndPoint: `${backendUrl}/ProductList`,
      columns: mediaColumns,
      formEntries: {
        content: "doctors description",
        title: "Doctors Name",
        photo: "doctors photo",
        heading: "Doctors information",
        apiEndPoint: `${backendUrl}/ProductList`,
      },
      reorderable: true,
    },
    {
      icon: "bi bi-bar-chart-line-fill",
      elements: "Statics",
      apiEndPoint: `${backendUrl}/statics`,
      columns: commonColumns,
      formEntries: {
        content: "statics text",
        title: "statics amount",
        heading: "Statics",
        apiEndPoint: `${backendUrl}/statics`,
      },
    },
    {
      icon: "bi bi-journal-richtext",
      elements: "Blog",
      apiEndPoint: `${backendUrl}/News`,
      columns: [
        { key: "images", label: "Photo", type: "image" },
        { key: "News", label: "Content", type: "html" },
        { key: "createdAt", label: "Date" }
      ],
      formEntries: {
        content: "news",
        photo: "news photo",
        heading: "blog",
        apiEndPoint: `${backendUrl}/News`,
      },
      reorderable: true,
    },
    {
      icon: "bi bi-images",
      elements: "Gallery",
      apiEndPoint: `${backendUrl}/portfolioList`,
      columns: mediaColumns,
      formEntries: {
        content: "portfolio link",
        title: "Photo description",
        photo: "photo",
        heading: "Gallery",
        apiEndPoint: `${backendUrl}/portfolioList`,
      },
      reorderable: true,
    },
    {
      icon: "bi bi-telephone-fill",
      elements: "Mobile",
      apiEndPoint: `${backendUrl}/CallUs`,
      columns: [{ key: "mobile", label: "Number" }, { key: "link", label: "Link" }],
      formEntries: {
        content: "link to phone",
        title: "mobile",
        heading: "mobile",
        apiEndPoint: `${backendUrl}/CallUs`,
      },
    },
    {
      icon: "bi bi-envelope-at-fill",
      elements: "Email",
      apiEndPoint: `${backendUrl}/Email`,
      columns: [{ key: "email", label: "Email" }, { key: "link", label: "Link" }],
      formEntries: {
        content: "link to email",
        title: "email",
        heading: "email",
        apiEndPoint: `${backendUrl}/Email`,
      },
    },
    {
      icon: "bi bi-geo-alt-fill",
      elements: "Location",
      apiEndPoint: `${backendUrl}/Adress`,
      columns: [{ key: "location", label: "Location" }, { key: "link", label: "Link" }],
      formEntries: {
        content: "google map",
        title: "physical location",
        heading: "address location",
        apiEndPoint: `${backendUrl}/Adress`,
      },
    },
    {
      icon: "bi bi-share-fill",
      elements: "Social Media",
      apiEndPoint: `${backendUrl}/socialMedia`,
      columns: [{ key: "images", label: "Icon", type: "image" }, { key: "link", label: "Link" }],
      formEntries: {
        content: "Social media link",
        photo: "social media icon",
        heading: "social media",
        apiEndPoint: `${backendUrl}/socialMedia`,
      },
    },
    {
      icon: "bi bi-chat-right-quote-fill",
      elements: "Testimonials",
      customComponent: <TestimonialsAdmin />,
    },
    {
      icon: "bi bi-translate",
      elements: "Translation",
      customComponent: <TranslationList />,
      formEntries: {
        heading: "Translation",
        apiEndPoint: `${backendUrl}/translations`,
      },
      customForm: <TranslationForm />,
    },
    {
      icon: "bi bi-person-circle",
      elements: "My Profile",
      customComponent: <ProfileUpdate />,
    },
    // Admin only sections
    isSuperAdmin && {
      icon: "bi bi-person-plus-fill",
      elements: "Register Admin",
      customComponent: (
        <div className="d-flex flex-column gap-4">
          <Register />
          <UserList />
        </div>
      ),
    },
    isSuperAdmin && {
      icon: "bi bi-building-fill",
      elements: "Partners",
      apiEndPoint: `${backendUrl}/stakeHolders`,
      columns: mediaColumns,
      formEntries: {
        content: "partner website",
        photo: "partners logo",
        heading: "partners",
        apiEndPoint: `${backendUrl}/stakeHolders`,
      },
    },
    {
      icon: "bi bi-camera-reels-fill",
      elements: "Company",
      apiEndPoint: `${backendUrl}/Company`,
      columns: mediaColumns,
      formEntries: {
        content: "Company youtube Account",
        title: " Company Name",
        photo: "Company icon",
        heading: "company",
        apiEndPoint: `${backendUrl}/Company`,
      },
    },
    {
      icon: "bi bi-house-door-fill",
      elements: "Home Content",
      apiEndPoint: `${backendUrl}/api/homeContent`,
      columns: [
        { key: "images", label: "Slide", type: "image" },
        { key: "homeTitle", label: "Title" },
        { key: "homeMessage", label: "Message", type: "html" }
      ],
      formEntries: {
        content: "Home body",
        title: "Home Title",
        photo: "slide photo",
        buttons: "Join Us Button",
        heading: "home",
        apiEndPoint: `${backendUrl}/api/homeContent`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-info-circle-fill",
      elements: "About Body",
      apiEndPoint: `${backendUrl}/About`,
      columns: commonColumns,
      formEntries: {
        content: "about body",
        title: "about title",
        heading: "About body",
        apiEndPoint: `${backendUrl}/About`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-list-check",
      elements: "About List",
      apiEndPoint: `${backendUrl}/AboutList`,
      columns: mediaColumns,
      formEntries: {
        content: "about list body",
        title: "about list title",
        photo: "photo/icon",
        heading: "about list",
        apiEndPoint: `${backendUrl}/AboutList`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-grid-3x3-gap-fill",
      elements: "Services Body",
      apiEndPoint: `${backendUrl}/service`,
      columns: commonColumns,
      formEntries: {
        content: "service body",
        title: "service title",
        heading: "service body",
        apiEndPoint: `${backendUrl}/service`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-person-lines-fill",
      elements: "Doctors Body",
      apiEndPoint: `${backendUrl}/product`,
      columns: commonColumns,
      formEntries: {
        content: "doctors body",
        title: "Doctors title",
        heading: "doctors body",
        apiEndPoint: `${backendUrl}/product`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-chat-left-text-fill",
      elements: "Contact Body",
      apiEndPoint: `${backendUrl}/ContactBody`,
      columns: commonColumns,
      formEntries: {
        content: "contact body",
        title: "contact title",
        heading: "contact body",
        apiEndPoint: `${backendUrl}/ContactBody`,
      },
    },
    isSuperAdmin && {
      icon: "bi bi-briefcase-fill",
      elements: "Portfolio Body",
      apiEndPoint: `${backendUrl}/portfolio`,
      columns: commonColumns,
      formEntries: {
        content: "portfolio body",
        title: "portfolio title",
        heading: "portfolio body",
        apiEndPoint: `${backendUrl}/portfolio`,
      },
    },
  ].filter(Boolean);

  useEffect(() => {
    if (!activeItem && admin_list.length > 0) {
      setActiveItem(admin_list[0]);
    }
  }, [admin_list, activeItem]);

  const handleSelect = (selectedName) => {
    const item = admin_list.find(i => i.elements === selectedName);
    if (item) {
      setActiveItem(item);
      setIsEditing(false);
      setCurrentEditData(null);
    }
  };

  const handleEdit = (data) => {
    setCurrentEditData(data);
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentEditData(null);
  };

  return (
    <div className="container-fluid p-0 bg-light dashboard-root" style={{ minHeight: "100vh" }}>
      <div className="row g-0">
        {/* Sidebar */}
        <div className="col-12 col-md-3 col-lg-2">
          <SideMenu
            admin_list={admin_list}
            onclick={handleSelect}
          />
        </div>

        {/* Main Content Area */}
        <div className="col-12 col-md-9 col-lg-10 p-4 main-content">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold text-dark m-0">{activeItem?.elements}</h3>
              <p className="text-muted small mb-0">Manage and update your {activeItem?.elements} here.</p>
            </div>

            {activeItem?.formEntries && !isEditing && (
              <button
                className="btn btn-primary shadow-sm px-4 py-2 fw-bold d-flex align-items-center"
                onClick={() => setIsEditing(true)}
              >
                <i className="bi bi-plus-circle me-2"></i> Create New
              </button>
            )}
          </div>

          <div className="content-container animate__animated animate__fadeIn">
            <div className="row g-4">
              {/* Form Section */}
              {isEditing && (
                <div className="col-12">
                  <div className="form-section-container">
                    {activeItem?.customForm ? (
                      React.cloneElement(activeItem.customForm, {
                        onCancel: handleCancelEdit,
                        onSuccess: () => { handleCancelEdit(); }
                      })
                    ) : (
                      <DashboardForm
                        entries={activeItem.formEntries}
                        currentData={currentEditData}
                        onCancel={handleCancelEdit}
                      />
                    )}
                  </div>
                </div>
              )}

              {/* Data Table Section */}
              <div className="col-12">
                {activeItem?.customComponent ? (
                  activeItem.customComponent
                ) : activeItem?.apiEndPoint ? (
                  <AdminDataTable
                    apiEndPoint={activeItem.apiEndPoint}
                    columns={activeItem.columns || commonColumns}
                    title={activeItem.elements}
                    onEdit={handleEdit}
                    reorderable={activeItem.reorderable}
                  />
                ) : (
                  <div className="bg-white rounded-3 shadow-sm p-5 text-center">
                    <i className="bi bi-collection-fill fs-1 text-muted mb-3 d-block"></i>
                    <h5 className="text-muted">No content view available for this category</h5>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .dashboard-root {
          font-family: inherit;
          background-color: #f0f2f5 !important;
        }
        .main-content {
          max-height: 100vh;
          overflow-y: auto;
        }
        .form-section-container {
          margin-bottom: 2rem;
        }
        .btn-primary {
          background-color: var(--primary-color);
          border: none;
          transition: transform 0.1s;
        }
        .btn-primary:active {
          transform: scale(0.98);
        }
        .breadcrumb-item a {
          text-decoration: none;
          color: var(--primary-color);
        }
        .card {
          border-radius: 8px;
          border: none;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }
        @media (max-width: 768px) {
          .main-content {
            max-height: none;
          }
        }
      `}</style>
    </div>
  );
}

export default ContentManagementForm;
